import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Decimal} from 'decimal.js';
import {InputNumber, Icon, Button } from 'mkui-fd';
import { CurrencyInput } from 'mkui-ext';
import  CurrencyDisabledView from './CurrencyDisabledView'


class MultipleCurrencyAdjustAmount extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    prefixCls: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.object,
    orgAmount: PropTypes.number,
    orgCcyCode: PropTypes.string,
    baseAmount: PropTypes.number,
    baseCcyCode: PropTypes.string,
    exchangeRate: PropTypes.number, // 汇率
    onChange: PropTypes.func,

  };

  static defaultProps = {
    prefixCls: 'mkui-adjust-amount',
    value: {},
    orgAmount: 0,
    orgCcyCode: '',
    baseAmount: 0,
    baseCcyCode: '',
    exchangeRate: 0, // 汇率
    precision: 2,
    max: Infinity,
    min: -Infinity,
    disabled: false,
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      mathSign: 'balance',
      amount:'',
      ccyCode: '￥',
    };
    this._initState();

  }
  /** *******************handle************************** */

  mathSignChangeHandle = () => {
    let { mathSign } = this.state;
    let { amount, adjustAmount } = this.data;
    let { precision } = this.props;
    let number = 0;
    if (mathSign === 'balance') {
      number = parseFloat(new Decimal(amount).add(new Decimal(adjustAmount))).toFixed(precision);
      this.setState({
        mathSign: 'plus',
      })
    } else {
      number = parseFloat(new Decimal(amount).minus(new Decimal(adjustAmount))).toFixed(precision);
      this.setState({
        mathSign: 'balance',
      })
    }

    this._setAmount(adjustAmount, number);
  }

  adjustAmountChangeHandle = (value) => {
    if (isNaN(value)) return false;
    let number = this._countAmount(value, 'adjust');
    this._setAmount(value, number);
  }

  adjustedAmountChangeHandle = (value) => {
    if (isNaN(value)) return false;
    let number = this._countAmount(value, 'adjusted');
    this._setAmount(number, value);
  }

  translateCurrency = (value) => {
    const { baseCcyCode, orgCcyCode, baseAmount, orgAmount } = this.props;
    let { orgAdjustAmount, orgAdjustedAmount, baseAdjustAmount, baseAdjustedAmount, isBaseCcy } = this.data;

    if (!isBaseCcy) {
      this.setState({
        currencyText: '切换成消费金额',
        adjustAmount: baseAdjustAmount,
        adjustedAmount: baseAdjustedAmount
      })

      this.data.ccyCode = baseCcyCode;
      this.data.amount = baseAmount;

    } else {
      this.setState({
        currencyText: '切换成收款金额',
        adjustAmount: orgAdjustAmount,
      })

      this.data.ccyCode = orgCcyCode;
      this.data.amount = orgAmount;
    }

    this.data.isBaseCcy = !this.data.isBaseCcy;
  }

  /** *******************inner method************************** */

  _initState() {
    const { orgAdjustedAmount, baseAdjustedAmount } = this.props.value;
    const { orgCcyCode, orgAmount, exchangeRate, precision } = this.props;
    this.data = {};
    let adjustAmount, mathSign, baseAdjustAmount;
    if (orgAdjustedAmount) {
      adjustAmount = parseFloat(new Decimal(orgAmount).minus(new Decimal(orgAdjustedAmount))).toFixed(precision);
      baseAdjustAmount = parseFloat(new Decimal(adjustAmount).mul(new Decimal(exchangeRate))).toFixed(precision);
      if (orgAmount >= orgAdjustedAmount) {
        mathSign = 'balance'
      } else {
        mathSign = 'plus'
      }
    }

    this.data = {
      isBaseCcy: false,
      ccyCode: orgCcyCode,
      amount: orgAmount,
      orgAdjustAmount: adjustAmount,
      orgAdjustedAmount,
      baseAdjustAmount,
      baseAdjustedAmount,
      adjustAmount
    };

    this.state = {
      mathSign,
      currencyText: '切换成收款金额'
    }
  }

  _countAmount(value, type) {
    let { mathSign } = this.state;
    let { amount } = this.data;
    let { precision } = this.props;
    let number = 0;
    if (type === 'adjust') {
      if (mathSign === 'balance') {
        number = parseFloat(new Decimal(amount).minus(new Decimal(value))).toFixed(precision);
      } else {
        number = parseFloat(new Decimal(amount).add(new Decimal(value))).toFixed(precision);
      }
    } else {
      if (mathSign === 'plus') {
        number = parseFloat(new Decimal(value).minus(new Decimal(amount))).toFixed(precision);
      } else {
        number = parseFloat(new Decimal(amount).minus(new Decimal(value))).toFixed(precision);
      }
    }
    return number
  }

  _setAmount(val1, val2) {
    let { isBaseCcy, ccyCode } = this.data;
    let { exchangeRate, precision } = this.props;
    let  adjustAmount, adjustedAmount, baseAdjustAmount, baseAdjustedAmount, amount;
    if (!isBaseCcy) {
      amount = this.props.orgAmount;
      adjustAmount = val1;
      adjustedAmount = val2;
      baseAdjustAmount =  parseFloat(new Decimal(val1).mul(new Decimal(exchangeRate))).toFixed(precision);
      baseAdjustedAmount = parseFloat(new Decimal(val2).mul(new Decimal(exchangeRate))).toFixed(precision);
    } else {
      amount = this.props.baseAmount;
      adjustAmount = parseFloat(new Decimal(val1).div(new Decimal(exchangeRate))).toFixed(precision);
      adjustedAmount = parseFloat(new Decimal(val2).div(new Decimal(exchangeRate))).toFixed(precision);
      baseAdjustAmount = val1;
      baseAdjustedAmount = val2;
    }

    this.data = {
      adjustAmount: val1,
      ccyCode,
      amount,
      orgAdjustAmount: adjustAmount,
      orgAdjustedAmount: adjustedAmount,
      baseAdjustAmount,
      baseAdjustedAmount,
      isBaseCcy
    }

    this.props.onChange({ orgAdjustedAmount: adjustedAmount, baseAdjustedAmount });
  }

  formatCcyCode(ccyCode) {
    return ccyCode === 'CNY' ? '￥' : ccyCode;
  }

  /** *******************render************************** */


  render() {
    const { disabled, precision, min, max } = this.props;
    let {  mathSign, currencyText } = this.state;
    let { amount, ccyCode } = this.data;
    let adjustedAmount
    if (this.data.isBaseCcy) {
      adjustedAmount = this.props.value.baseAdjustedAmount;
    } else {
      adjustedAmount = this.props.value.orgAdjustedAmount;
    }
    if (mathSign === 'balance') {

      this.data.adjustAmount = parseFloat(new Decimal(amount).minus(new Decimal(adjustedAmount))).toFixed(precision);
    } else {
      this.data.adjustAmount = parseFloat(new Decimal(adjustedAmount).minus(new Decimal(amount))).toFixed(precision);
    }
    let adjustAmount = this.data.adjustAmount;


    return (
      <div className='mkui-adjust-amount'>
        {!disabled && (
        <div>
          <div className="adjust-item">
            <div className="item-control-warpper">
              <CurrencyInput precision={precision} value={amount}  disabled={true} size="large" symbol={this.formatCcyCode(ccyCode)} />
            </div>
          </div>
          <div className='math-sign'>
            <Button onClick={this.mathSignChangeHandle}>
              <Icon type={mathSign} theme="outlined" />
            </Button>
          </div>
          <div className="adjust-item">
            <div className="item-control-warpper">
              <InputNumber
                value={adjustAmount}
                onChange={this.adjustAmountChangeHandle}
                theme="surround"
                precision={precision}
                placeholder="请输入金额"
                min={min}
                max={max}
              />
            </div>
          </div>
          <div className='math-sign'>
            <Icon type="right" theme="outlined" />
          </div>
          <div className="adjust-item">
            <div className="item-control-warpper">
              <InputNumber
                value={adjustedAmount}
                onChange={this.adjustedAmountChangeHandle}
                theme="surround"
                precision={precision}
                placeholder="请输入金额"
                min={min}
                max={max}
              />
            </div>
          </div>
          <div className='math-sign' onClick={this.translateCurrency}>
            <Icon className='sign' type="transfer" theme="outlined" />
            <span className='sign-explain'>{currencyText}</span>
          </div>
        </div>
        )}
        {disabled && (
          <CurrencyDisabledView data={this.props}></CurrencyDisabledView>
        )}
      </div>
    );
  }
}

export default MultipleCurrencyAdjustAmount;
